export default {
  namespaced: true,

  state: {
    statusColors: {
      pending: "jaffa",
      disapproved: "burnt-sienna",
      disabled: "fc-stroke",
      canceled: "burnt-sienna",
      precompleted: "fc-stroke",
      completed: "jungle-green",
    },
  },

  getters: {
    statusColorsList(state) {
      return state.statusColors;
    },
  },
};
